import { GdprCountries } from 'src/components/pages/SmartLink/PrivacyBanner/GdprCountries'

export const trackingModeGdpr = (countryName: string) => GdprCountries.includes(countryName)
